import { render, staticRenderFns } from "./TeamDisplay.vue?vue&type=template&id=2674f03c&scoped=true"
import script from "./TeamDisplay.vue?vue&type=script&lang=js"
export * from "./TeamDisplay.vue?vue&type=script&lang=js"
import style0 from "./TeamDisplay.vue?vue&type=style&index=0&id=2674f03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674f03c",
  null
  
)

export default component.exports